import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import useWorkflowSteps from "backend/hooks/workflows/useWorkflowSteps";
import React from "react";

export type IStepConfig = {
  title: string | JSX.Element;
  state: string;
};
const WorkflowSteps = (props: {
  workflowId?: string;
  currentState: string;
  showSteps: IStepConfig[];
  isVertical?: boolean;
}) => {
  const { data: steps, isLoading: isLogsLoading } = useWorkflowSteps(
    props.workflowId
  );

  if (!steps) return null;

  const getActiveStepIndex = () => {
    let index = 0;
    if (props.currentState === "approvalrejected") return index;
    while (
      index < props.showSteps.length &&
      props.showSteps[index].state !== props.currentState
    )
      index += 1;
    return index;
  };
  return (
    <div style={{ width: "100%" }}>
      {steps ? (
        <Stepper
          activeStep={getActiveStepIndex()}
          orientation={props.isVertical ? "vertical" : "horizontal"}
        >
          {props.showSteps.map((step) => {
            const [findStep] = steps.filter((s) => step.state === s.state);
            return (
              <Step>
                <StepLabel>
                  {step.title}
                  <div>{findStep?.username}</div>
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
      ) : null}
    </div>
  );
};

export default WorkflowSteps;
